export default __webpack_public_path__ + "static/media/bathtubafter.1d70fbe0.jpg";